import { ca } from '@cian/analytics';

export function trackNavigationToListingJK(id?: number) {
  return ca('eventSite', {
    name: 'oldevent',
    category: 'CompareJK',
    action: 'to_listingjk',
    ...(id ? { products: [{ id, offerType: 'JK' }] } : {}),
  });
}

export function trackNavigationToCardJK(id: number, siteType: 'desktop' | 'mobile' = 'desktop') {
  return ca('eventSite', {
    name: 'oldevent',
    category: 'CompareJK',
    action: 'to_cardjk',
    page: {
      siteType,
      pageType: 'ListingCompareJK',
      listingType: 'list',
    },
    products: [{ id, offerType: 'JK' }],
  });
}
